import {GET_AVAILABILITY_SUCCESS} from "../../../reducers/availabilityReducer";


export const getAvailabilitySuccess = (reports) =>{
    return {
        type: GET_AVAILABILITY_SUCCESS,
        payload: {reports}
    }
}